const theme = {
    light: "light",
    dark: "dark",
};

export default theme;
